<template>
  <b-row>
    <b-col>
      <p
        class="mt-3 text-dark"
        style="font-weight: 500"
      >
        Tổng số:
        {{ totalItems }}
      </p>
    </b-col>
    <b-col>
      <BPaginationNavCustom
        :number-of-pages="totalPages"
        :current-page="currentPage"
        :total-page="totalPages"
        @page-change="$emit('page-change')"
      ></BPaginationNavCustom>
    </b-col>
  </b-row>
</template>

<script>
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  name: 'Pagination',
  components: {
    BPaginationNavCustom,
  },
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    currentPage() {
      return this.$route.query.page || 1;
    },
  },
  data() {
    return {};
  },
};
</script> 
